import PropTypes from 'prop-types'

/**
 * Extracted to be able to extend prop-types.
 *
 * @type {Object}
 */
const vehicleMaintenanceTaskCompletionReasonPropTypeEntry = {
    defaultValue: PropTypes.bool,
    maintenanceTaskCompletionReasonId: PropTypes.string,
    stringCode: PropTypes.string
}

/**
 * @typedef {Object} VehicleMaintenanceTaskCompletionReason
 * @property {string} [maintenanceTaskCompletionReasonId] - The maintenance task completion reason unique identifier
 * @property {string} [stringCode] - The string code which when translated describes the reason
 * @property {boolean} defaultValue - True if the reason should be the default selected one when presented in a UI
 */
export const vehicleMaintenanceTaskCompletionReasonPropType = PropTypes.shape(
    vehicleMaintenanceTaskCompletionReasonPropTypeEntry
)
